import { useRouteError } from 'react-router'

export const ReactRouterErrorBoundary = () => {
  const error = useRouteError()

  throw error
}
